// Generated by Melange

import ButtonModuleCss from "./button.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as LucideReact from "../lucideReact/lucideReact.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import Clsx from "clsx";
import * as LucideReact$1 from "lucide-react";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = ButtonModuleCss;

const make = React.forwardRef(function (Props, ref) {
  let ariaControls = Props.ariaControls;
  let ariaExpanded = Props.ariaExpanded;
  let ariaLabel = Props.ariaLabel;
  let ariaPressed = Props.ariaPressed;
  let children = Props.children;
  let className = Props.className;
  let disabled = Props.disabled;
  let loading = Props.loading;
  let popovertarget = Props.popovertarget;
  let variant = Props.variant;
  let type_ = Props.type_;
  let onClick = Props.onClick;
  const arg = null;
  let tmp = {
    className: css.contents
  };
  if (children !== undefined) {
    tmp.children = Caml_option.valFromOption(children);
  }
  let tmp$1 = {
    children: [
      (function (param) {
        return Stdlib__Option.value(param, arg);
      })(Stdlib__Option.bind(loading, (function (loading) {
        if (loading) {
          return Caml_option.some(JsxRuntime.jsx(LucideReact$1.Loader2, Curry._4(LucideReact.Loader2.makeProps, undefined, css.spinner, undefined, undefined)));
        }
        
      }))),
      JsxRuntime.jsx("span", tmp)
    ],
    className: Clsx(className, css.root, variant !== undefined && variant !== "primary" ? css.root_variant_icon : css.root_variant_primary, Stdlib__Option.bind(loading, (function (loading) {
      if (loading) {
        return css.root_state_loading;
      }
      
    }))),
    type: Stdlib__Option.value(type_, "button")
  };
  const tmp$2 = Stdlib__Option.map((function (prim) {
    return prim;
  }), (ref == null) ? undefined : Caml_option.some(ref));
  if (tmp$2 !== undefined) {
    tmp$1.ref = Caml_option.valFromOption(tmp$2);
  }
  if (ariaControls !== undefined) {
    tmp$1["aria-controls"] = Caml_option.valFromOption(ariaControls);
  }
  if (ariaExpanded !== undefined) {
    tmp$1["aria-expanded"] = Caml_option.valFromOption(ariaExpanded);
  }
  if (ariaLabel !== undefined) {
    tmp$1["aria-label"] = Caml_option.valFromOption(ariaLabel);
  }
  if (ariaPressed !== undefined) {
    tmp$1["aria-pressed"] = Caml_option.valFromOption(ariaPressed);
  }
  if (disabled !== undefined) {
    tmp$1.disabled = Caml_option.valFromOption(disabled);
  }
  if (onClick !== undefined) {
    tmp$1.onClick = Caml_option.valFromOption(onClick);
  }
  return React.cloneElement(JsxRuntime.jsxs("button", tmp$1), {
    popovertarget: popovertarget
  });
});

export {
  make,
}
/* css Not a pure module */
